import { SchedulePositionLiveState } from "../interfaces/ISchedules";

export const getPositionLiveStateLabel = (state?: SchedulePositionLiveState): string => {
  switch (state) {
    case "IN_PROGRESS":
      return "W toku";
    case "FINISHED":
      return "Zakończona";
    case "PLANNED":
    default:
      return "Zaplanowana";
  }
};

export type PositionStatusChipColor = "default" | "info" | "success";

export const getPositionLiveStateChipColor = (state?: SchedulePositionLiveState): PositionStatusChipColor => {
  switch (state) {
    case "IN_PROGRESS":
      return "info";
    case "FINISHED":
      return "success";
    case "PLANNED":
    default:
      return "default";
  }
};
